import { coldarkDark as dark} from 'react-syntax-highlighter/dist/esm/styles/prism';
import SyntaxHighlighter from 'react-syntax-highlighter';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from "axios";

export default function Content(props) {
    // const [myData, setMyData] = useState([])
    // const [loading, setLoading] = useState(false)
    // var option = {
    //   method: 'GET',
    //   url: 'https://karlson.herokuapp.com/'
    // };
    // useEffect(async()=>{
    //     setLoading(true)
    //     axios
    //     .request(option)
    //     .then(async function(response) {
    //         let data = await JSON.stringify(response.data.data)
    //         setMyData(JSON.parse(await data))
    //         await console.log("Succesfully fetched all posts!")
    //     })
    //     .catch((err)=>{
    //         console.log(err);
    //     })
    //     .finally(()=>{
    //         setLoading(false);
    //     })
    // }, [])
    // if (loading) return <div className="loader"><span className="load"></span><span className="load"></span><span className="load"></span></div>;
    return (
      <>
      <div className = "container text-center">
      <br/>
      <h1>
        Hello World👋🏻, I am Eklavya Chandra
      </h1>
      <h3>Full Stack Web Developer</h3><br/>
      <h2 className="text-start my-2">Let me introduce myself &rarr;</h2>
      <h4 className="text-start my-2">
      <SyntaxHighlighter style={dark}>
      A non-professionalist and undergraduate developer with some skills playing through APIs and making content you love. Glad to see you here.
      </SyntaxHighlighter>
      </h4><br/>
      {/*<h2 className="text-start">Here's some of my latest blogs &rarr;</h2><br/>*/}
      {/*Blog content*/}
       {/*<div className="row">
         {myData.slice(myData.length-2).map((post)=>{
             return(
             <div className="col-lg-6 mb-4" key={post.sno}>
                 <div className="card">  
                     <div className="card-body">
                         <h5 className="card-title">{post.title}</h5>
                         <p className="card-text">
                             {post.content.split(' ').slice(0,21).join(' ') + '..read more'}
                         </p>
                         <Link to={"/blog/" + post.slug} className="sbtn  next-arrow-btn green-btn">
                             View Blog
                         </Link>
                     </div>
                 </div>
             </div>)
          })}
         </div>*/}
      {/*End of blog content*/}
      <div className="text-start">
      <h2 >Social Links &rarr;</h2>
      <a href="https://github.com/eklavyadev" target="_blank" className="sbtn mx-2 my-3 key-btn black-btn">GitHub</a>
      <a href="https://www.instagram.com/eklavyachandra" target="_blank" className="mx-2 my-3 sbtn key-btn pink-btn">Instagram</a>
      <a href="https://twitter.com/eklavyachandra" target="_blank" className="mx-2 my-3 sbtn key-btn blue-btn">Twitter</a>
      </div>
      <br/>
      {/* Footer */}
      <h4>Made with 💖 and PERN Stack</h4>
      </div>
    </>
  );
}
